import { externalLinks } from "assets/external-links/external-links";
import Content, { ContentNS } from "content/content";
import SessionConsent from "features/consent/components/session-consent/SessionConsent";
import useMultipaxSession from "features/shared/hooks/useMultiPaxSession";
import Body from "features/shared/styles/typography/Body.styled";
import { Trans, useTranslation } from "react-i18next";
import { useAppStore } from "store/store";
import { withPageLang } from "utils";

import ConsentCard from "./styles/ConsentCard.styled";
// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import ConsentInfo from "./styles/ConsentInfo-APP_CLIENT.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import { MicroHeaderXS } from "features/shared/styles/typography/MicroHeaderXS.styled";

export default function ConsentForm() {
  const locale = useAppStore((state) => state.locale);
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.consent });
  const isMultiPax = useMultipaxSession();
  const { t } = useTranslation("consent");

  const title = text("validation-title");
  const subtitle = text("validation-subtitle");

  const privacyText = text("privacy.text");

  return (
    <ConsentCard>
      <ConsentInfo>
        {title !== "" ? <TertiaryHeader>{title}</TertiaryHeader> : null}
        {subtitle !== "" ? <Body>{subtitle}</Body> : null}

        <Trans
          t={t}
          i18nKey="description-1"
          components={{
            text: <MicroHeaderXS />,
            list: <ul />,
            "list-item": <li />,
            header: <MicroHeader />,
          }}
        />

        {privacyText !== "" ? (
          <MicroHeaderXS>
            <span>{privacyText} </span>
            <a
              data-testid="privacy-notice-link"
              href={withPageLang(externalLinks.privacyNotice, locale)}
              target="_blank"
              rel="noreferrer"
            >
              {text("privacy.link-title")}
            </a>
          </MicroHeaderXS>
        ) : null}
        <MicroHeaderXS>
          <span>{text("more-info.text")} </span>
          <a
            data-testid="zamna-pax-link"
            href={withPageLang(externalLinks.paxWebpage, locale)}
            target="_blank"
            rel="noreferrer"
          >
            {text("more-info.link-title")}
          </a>
        </MicroHeaderXS>
        <MicroHeaderXS>
          {isMultiPax
            ? text("require-consent-multipax")
            : text("require-consent")}
        </MicroHeaderXS>
      </ConsentInfo>
      <SessionConsent />
    </ConsentCard>
  );
}
